var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6C12 9.30857 9.30857 12 6 12C2.69143 12 0 9.30857 0 6C0 2.69143 2.69143 0 6 0C9.30857 0 12 2.69143 12 6ZM10.9714 6C10.9714 3.25714 8.74286 1.02857 6 1.02857C3.25714 1.02857 1.02857 3.25714 1.02857 6C1.02857 8.74286 3.25714 10.9714 6 10.9714C8.74286 10.9886 10.9714 8.74286 10.9714 6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.00061 5.12598C5.70919 5.12598 5.48633 5.34883 5.48633 5.64026V8.26312C5.48633 8.55455 5.70919 8.77741 6.00061 8.77741C6.29204 8.77741 6.5149 8.55455 6.5149 8.26312V5.64026C6.5149 5.34883 6.29204 5.12598 6.00061 5.12598Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00061 3.24023C5.86347 3.24023 5.72633 3.29166 5.64061 3.39452C5.53776 3.48023 5.48633 3.61738 5.48633 3.75452C5.48633 3.78881 5.48633 3.82309 5.50347 3.85738C5.50347 3.89166 5.52061 3.92595 5.53776 3.96023C5.5549 3.99452 5.57204 4.01166 5.58919 4.04595C5.60633 4.08023 5.62347 4.09738 5.65776 4.13166C5.84633 4.32023 6.18919 4.32023 6.37776 4.13166C6.3949 4.11452 6.42919 4.08023 6.44633 4.04595C6.46347 4.01166 6.48061 3.99452 6.49776 3.96023C6.5149 3.92595 6.5149 3.89166 6.53204 3.85738C6.53204 3.82309 6.54919 3.78881 6.54919 3.75452C6.54919 3.61738 6.49776 3.48023 6.3949 3.39452C6.2749 3.29166 6.13776 3.24023 6.00061 3.24023Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.ae65b18e9078707e9359de2543989656.svg";
export { ForwardRef as ReactComponent };